import React, { useCallback, useContext, useEffect, useState } from 'react';
import Card from './Card';
import styles from './Plan.module.scss';
import { PlanSelectionStateContext } from '../../context/plan-selection-context';
import Toast from '../Toast/Toast';
import Spinner from 'react-bootstrap/Spinner';
import W3LogoButton from '../../SharedLib/Component/Buttons/W3LogoButton/W3LogoButton';
import { removeCookie } from '../../SharedLib/Util/CookieUtil';
import { extractUserInfoCookieData } from '../../SharedLib/Util/UserSessionUtil';
import { getSanitizedRedirectUrl, safeRedirect } from '../../SharedLib/Util/RedirectUtil';
import { getPathfinderUrl } from '../../SharedLib/Util/EnvironmentUtil';
import { fetchProfile } from '../../SharedLib';
import { getProfileBaseUrl } from '../../SharedLib/Util/InternalProjects/ProfileUtil';
import LoadingBox from '../../SharedLib/Component/LoadingBox/LoadingBox';

const PlanSelection: React.FC = () => {
  const { plans, toggleAnnual, purchasePlan, displayToast, setDisplayToast, toastDetails, isLoading } =
    useContext(PlanSelectionStateContext);
  const [isAnnualPlan, setIsAnnualPlan] = useState(false);
  const [userinfoLoading, setUserinfoLoading] = useState(true);

  const handleToastClosed = () => {
    setDisplayToast(false);
  };

  const handleToggleAnnual = () => {
    toggleAnnual();
    setIsAnnualPlan(!isAnnualPlan);
  };

  const init = useCallback(async () => {
    try {
      setUserinfoLoading(true);

      await fetchProfile({
        method: 'PATCH',
        url: `${getProfileBaseUrl()}/api/user/unset-is-first-login`,
      });

      const redirectUrl = getSanitizedRedirectUrl({
        fallback: getPathfinderUrl(),
      });
      safeRedirect(redirectUrl);
    } catch (error) {
      console.log('error', error);
      setUserinfoLoading(false);
    }
  }, []);

  useEffect(() => {
    removeCookie('showPlanSelection');

    init();

    if (window.innerWidth <= 768) {
      const element = document.getElementById('pro_monthly');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
          inline: 'center',
        });
      }
    }
  }, []);

  {
    /*const ClassRoom = () => {
    return (
      <div className={`row ${styles.classroomRow}`}>
        <div className="col-lg-10 col-md-10 col-sm-10">
          <div className={styles.classroomSection}>
            <div className={`${styles.classroomText}`}>
              <div className="col-12">CLASSROOM</div>
            </div>
            <div className="row">
              <div className={`col-4 ${styles.priceUponRequest}`}>Price available upon request</div>
              <div className={`col-5 ${styles.learningSolution}`}>Let's tailor a learning solution that fits your group's unique needs</div>
              <div className="col-3 m-auto">
                <a target='_blank' href="/contact-us" className={`btn ${styles.outlineBtn}`}>More Info</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  */
  }

  const ToggleWrapper = () => {
    return (
      <div className={styles.toggleWrapper}>
        <div className={styles.labels}>
          <span style={{ color: '#718096', fontWeight: 600 }}>Monthly</span>
          <label className={styles.switch}>
            <input type="checkbox" checked={isAnnualPlan} onChange={handleToggleAnnual} />
            <span className={styles.slider}></span>
          </label>
          <span style={{ fontWeight: 600 }}>Yearly (Save 33%)</span>
        </div>
      </div>
    );
  };

  if (userinfoLoading) {
    return <LoadingBox className={styles.loadingBox} />;
  }

  const academyPlan = plans.find(plan => plan.id === 'classroom');

  return (
    <div className={styles.planSelectionContainer}>
      <Toast displayToast={displayToast} onToastClosed={handleToastClosed} {...toastDetails} />

      {/* For DeskTop */}
      <div className="d-none d-sm-block">
        <div className={` ${styles.headerLogo}`}>
          <W3LogoButton loggedIn={true} width="69" height="65" />
        </div>
        <div className={` ${styles.chooseYourPlan}`}>
          <h1>Welcome to W3Schools! 👋</h1>
          <p>
            <h5>Choose the right plan for you 💚</h5>
          </p>

          <ToggleWrapper />
        </div>
      </div>

      {/* For Mobile */}
      <div className={` ${styles.headerLogo} d-block d-sm-none`}>
        <W3LogoButton loggedIn={true} width="50" height="46" />
        <div className={` ${styles.chooseYourPlan}`}>
          <h1>Welcome to W3Schools! 👋</h1>
          <p>
            <h5>Choose the right plan for you 💚</h5>
          </p>

          <ToggleWrapper />
        </div>
      </div>

      <div className={`${styles.cardsWrapper} `}>
        <div className={`${styles.cardsContainer} `}>
          <div className={`row ${styles.cardsRow}`}>
            {plans
              .filter(plan => plan.isVisible && plan.id !== 'classroom')
              .map((plan, index) => (
                <div className={`${styles.cardColumn}`} key={index} id={plan.id}>
                  {(plan.id === 'plus_monthly' || plan.id === 'plus_yearly') && <div className={styles.plusCardHeader}></div>}
                  <Card {...plan} id={plan.id} />
                </div>
              ))}
          </div>
        </div>
      </div>

      {/* Render Academy (classroom) plan horizontally below the cards */}
      {academyPlan && (
        <div className={styles.academyRow}>
          <Card {...academyPlan} id="classroom" isHorizontal={true} />
        </div>
      )}

      {/* For Mobile
      <div className='d-block d-sm-none'>
        <div className={` ${styles.chooseYourPlan}`}>
          <ToggleWrapper />
          <p>
          By subscribing to the Plus Plan you support the W3Schools mission to make learning available to everyone - no matter their background. <b>With W3Schools Plus you support 30 learners per month!</b>
          </p>
        </div>
      </div>
       */}
      {/* For DeskTop */}
      {/*<div className='d-none d-sm-block'>
        <ClassRoom />
      </div>
            */}
      <div className={` ${styles.chooseYourPlan}`}>
        <p>
          By subscribing to the Plus Plan you support the W3Schools mission to make learning available to everyone - no matter their
          background. <br /> <b>With W3Schools Plus you support 30 learners per month!</b>
        </p>
      </div>
      {/* {
        <div className={`${styles.actionButtons}`}>
          <a target="_blank" href="https://www.w3schools.com/pro/index.php#plans-section" className={`btn ${styles.outlineBtn}`}>
            Compare plans
          </a>
        </div>
      } */}
      {/*<div className='d-block d-sm-none'>
        <ClassRoom />
      </div>
*/}
    </div>
  );
};

export default PlanSelection;
